import { useSelector } from 'react-redux';
import { animated, useTransition } from 'react-spring';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import PreviewComponent from '../components/Preview';
import Head from '../components/Head';
import LargeSpinner from '../components/LargeSpinner';

import { useServerState, useIsomorphicLayoutEffect } from '../lib/hooks';
import { IStore } from '../types';

function Preview() {
    let router = useRouter();
    let isOnboardingSuccessful = useSelector<IStore, boolean | undefined>((state) => state.website?.properties?.onboardingSuccessful);

    let { isLoading } = useServerState();
    let [isRedirecting, setIsRedirecting] = useState(false);
    let [isReady, setIsReady] = useState(false);

    useIsomorphicLayoutEffect(() => {
        if (false === isLoading && true !== isOnboardingSuccessful) {
            setIsRedirecting(true);

            router.push('/');
        }
    }, [isLoading]);

    useEffect(() => {
        setIsReady(false === isLoading && false === isRedirecting);
    }, [isLoading, isRedirecting]);

    let title = useSelector<IStore, string | undefined | null>((state) => state.website?.title);

    const transitions = useTransition(false === isReady, null, {
        from: { opacity: 1 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        trail: 1000
    });

    return (
        <div className="h-screen">
            <Head>
                <title>{(title && title.replace(/(\r\n|\n|\r)/gm, ' ')) || 'Webcard'}</title>
            </Head>

            {isReady && <PreviewComponent baseHref="/preview" />}

            {transitions.map(
                ({ item, props, key }) =>
                    item && (
                        <animated.div
                            style={props}
                            key={key}
                            className="z-50 fixed inset-0 bg-white flex flex-col justify-center items-center"
                        >
                            <LargeSpinner />
                            <div className="text-lg">Vorschau wird geladen</div>
                        </animated.div>
                    )
            )}
        </div>
    );
}

export default Preview;
